/**
 * Shared gate for **community profile** surfaces (profiles, playlists in profile UX,
 * my library shell, comment profile links, header menu avatars, etc.).
 *
 * Gated by the OpenShift / config flag (`features.communityProfile`), set per
 * environment via the FEATURES_COMMUNITY_PROFILE env var. If OFF (0) the feature
 * is completely disabled, full stop.
 *
 * Returns:
 *   enabled  — true when the current user should see community profile features
 *   loading  — always false (no async resolution needed)
 */
import { get as getConfig } from '../../../config/index'

interface CommunityEnabledResult {
  enabled: boolean
  loading: boolean
}

export default function useCommunityEnabled (): CommunityEnabledResult {
  const config = getConfig()
  const enabled = !!config?.features?.communityProfile

  return { enabled, loading: false }
}
